// Slide Cart by AMP's templates are not editable, 
// we use it's callbacks for custom functionality
window.SLIDECART_LOADED = function(cart) {
  hideSampleQuantitiesInCart(cart);
}

window.SLIDECART_UPDATED = function(cart) {
  hideSampleQuantitiesInCart(cart);
}

function hideSampleQuantitiesInCart(cart) {
  console.log(cart.items)
  cart.items.forEach(function(item) {
    if (item.price === 0 || item.product_title.toLowerCase().includes("free sample")) {
      const quantityEl = document.querySelector(`[data-line-item-id="${item.id}"] .quantity-selector`);
      if (quantityEl) {
        quantityEl.style.opacity = '0';
        quantityEl.style.pointerEvents = 'none';
      }
    }
  });
}
